import React from "react";

export default function Footer() {
  return (
    <h4>
      <a href="https://github.com/lbferrand/react-app">
        Open Soucer by Luciana Ferrand
      </a>
    </h4>
  );
}
